import React from 'react';

const Back = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 12 16" fill="none">
      <path
        d="M5.99932 11.3327L2.66602 7.99931L5.99935 4.66602"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66602 8H13.3327"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Back;
